export const isEcoFSubOrgOpen = process.env.REACT_APP_IS_OPEN_ECO_F_SUB_ORG === "true";

export const isEcoFPlanSettingOpen = process.env.REACT_APP_IS_OPEN_ECO_F_PLAN_SETTING === "true";

export const isApiKeysOpen = process.env.REACT_APP_IS_OPEN_API_KEYS === "true";

export const isGoalSettingOpen = process.env.REACT_APP_IS_OPEN_GOAL_SETTING === "true";

export const isScope3Open = process.env.REACT_APP_IS_OPEN_SCOPE_3 === "true";

export const isCat15Open = process.env.REACT_APP_IS_OPEN_CAT15 === "true";

// Shown unless explicitly "false", so every existing deployment keeps Needs Attention without setting anything.
export const isCat15NeedsAttentionOpen = process.env.REACT_APP_IS_OPEN_CAT15_NEEDS_ATTENTION !== "false";
